import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class PaymentProcessingLoader extends Loader {}

export const paymentProcessingLoader = new PaymentProcessingLoader({
  service: SERVICES.payProcessing,
})
